// eslint-disable-next-line jira/import-whitelist
import { WEB_RESOURCE_MAP } from '@atlassian/jira-dashboard-common/src/constants.tsx';
import type {
	WebResourceResponse,
	WebResourceName,
} from '@atlassian/jira-dashboard-common/src/types.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

const CRITICAL_DEPENDENCIES = [
	'jira.webresources:util',
	'jira.webresources:feature-flags',
	'com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
];

const JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (moduleNames: WebResourceName[]): Promise<WebResourceResponse | null> => {
	if (moduleNames.length === 0) {
		return Promise.resolve(null);
	}

	const contextsToRequire = moduleNames.map((amdModule) => WEB_RESOURCE_MAP[amdModule]);

	const payload = {
		r: [],
		c: [...CRITICAL_DEPENDENCIES, ...contextsToRequire],
		xc: [JIRA_HERITAGE_CRITICAL_BATCH],
		xr: [],
	};

	return fetchJson<WebResourceResponse>('/rest/webResources/1.0/resources?operation=FetchWRMData', {
		method: 'POST',
		body: JSON.stringify(payload),
	});
};
